import { Card, CardBody, Col } from "reactstrap";
import { SimpleVerticalDividerTitle } from "../../../Constants/Constants";
import { SimpleHorizontalDividerData, SimpleVerticalDividerSubTitle } from "../../../Data/UiKits/Divider";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SimpleVerticalDivider = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={SimpleVerticalDividerTitle} span={SimpleVerticalDividerSubTitle} />
        <CardBody className="main-divider">
          <div className="common-align">
            {SimpleHorizontalDividerData.map((item, index) => (
              <div className={`vr bg-${item}`} key={index} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SimpleVerticalDivider;
